import React from 'react';
import { TourProvider } from '@reactour/tour';
import { tourSteps } from './components/common/tour/tourSteps';
import TourContent from './components/common/tour/TourContent';

interface TourWrapperProps {
  children: React.ReactNode;
}

const TourWrapper: React.FC<TourWrapperProps> = ({ children }) => {
  return (
    <TourProvider
      steps={tourSteps}
      showNavigation={false}
      showDots={false}
      showBadge={false}
      afterOpen={(target) => {
        // Scroll to target element
        if (target) {
          setTimeout(() => {
            target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }, 100);
        }
      }}
      onClickClose={({ setCurrentStep, currentStep, steps, setIsOpen }) => {
        // Switch back to Chart tab when tour is closed
        const event = new CustomEvent('tour-switch-tab', { 
          detail: { tabKey: 'charts' },
        });
        window.dispatchEvent(event);
        setIsOpen(false);
      }}
      components={{
        Content: ({ currentStep, setIsOpen, setCurrentStep, content }) => (
          <TourContent
            currentStep={currentStep}
            totalSteps={tourSteps.length}
            setIsOpen={setIsOpen || (() => {})}
            setCurrentStep={setCurrentStep}
            content={content}
          />
        ),
      }}
      styles={{
        popover: (base) => ({
          ...base,
          borderRadius: '8px',
          boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.15)',
          padding: 0,
        }),
        maskArea: (base) => ({
          ...base,
          rx: 8,
        }),
        badge: (base) => ({
          ...base,
          display: 'none',
        }),
        dot: (base) => ({
          ...base,
          display: 'none',
        }),
        navigation: (base) => ({
          ...base,
          display: 'none',
        }),
      }}
    >
      {children}
    </TourProvider>
  );
};

export default TourWrapper;

